import React, { useEffect, useState, useCallback } from "react";
import { Form, Checkbox, Dropdown } from "semantic-ui-react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import swal from "sweetalert";
import * as yup from "yup";
import { cupomSchema } from "../../Validation/CupomValidation";
import {
  StyledLabel,
  StyledButton,
  ContainerLimitante,
  StyledCheckbox,
  StyledLabelRed,
  StyledCheck,
  StyledCheckboxLeft,
  Field,
} from "./styles";
import AlunosSelector from "../../../AlunosSelector";
import TreinamentosSelector from "../../../TreinamentosSelector";

const Formulario = (props) => {
  const [testCupom, setTestCupom] = useState({
    codigo: [],
    desconto: 1,
    descricao: "",
    maxUso: 0,
    dataVencimento: "",
    emails: [],
  });

  const [aluno, setAluno] = useState("");
  const [alunoSearch, setAlunoSearch] = useState("");
  const [alunosOptions, setAlunosOptions] = useState([]);

  const [aplicavel, setAplicavel] = useState("");

  const [treinamentos, setTreinamentos] = useState("");
  const [treinaExibe, setTreinaExibe] = useState([]);
  const [utilsTreinamento, setUilsTreinamento] = useState([]);

  const [porcent, setPorcent] = useState(1);
  const [valor, setValor] = useState(0);

  const [ativo, setAtivo] = useState("");
  const [verifAtivo, setVerifAtivo] = useState(0);

  const [numMaxUsosDeterminado, setNumMaxUsosDeterminado] = useState(false);
  const [dataVencimentoDeterminada, setDataVencimentoDeterminada] = useState(
    false
  );
  const [customValidade, setCustomValidade] = useState(false);

  const [rawCupom, setRawCupom] = useState(null);
  const [loading, setLoading] = useState(false);

  const utils = [
    {
      key: 0,
      text: "Indeterminado",
      value: "Indeterminado",
    },
    {
      key: 1,
      text: "Determinado",
      value: "Determinado",
    },
  ];
  const utilsPaga = [
    {
      key: 0,
      text: "Boleto / Débito em Conta",
      value: "Boleto / Débito em Conta",
    },
    {
      key: 1,
      text: "PicPay",
      value: "PicPay",
    },
    {
      key: 2,
      text: "Cartão de Credito",
      value: "Cartão de Credito",
    },
    {
      key: 3,
      text: "Bitcoin",
      value: "Bitcoin",
    },
  ];

  const handleCupom = useCallback(
    (e) => {
      const newCupom = { ...testCupom };
      const { name, value } = e.target;
      newCupom[name] = value;
      setTestCupom(newCupom);
    },
    [testCupom]
  );

  const handleAlunoChange = (value) => {
    setAluno(value);
  };

  const handleAlunoSearchChange = useCallback((e) => {
    const search = e.target.value;

    setAlunoSearch(search);

    api.get(`alunos?search=${search}&limit=15`).then((res) => {
      if (res.data.length > 0) {
        const options = res.data.map((pessoa, index) => ({
          key: index,
          text: `(${pessoa.email}) [ID: ${pessoa.id}]`,
          value: pessoa.id,
        }));
        setAlunosOptions(options);
        return;
      }
      setAlunosOptions([{ key: 0, text: `Nenhum aluno`, value: 0 }]);
    });
  });

  const handleInputChangeValor = (e) => {
    if (valor === 1) {
      setValor(0);
    }
    if (valor !== 1) {
      setValor(1);
      setPorcent(0);
    }
    return;
  };
  const handleInputChangePorcentagem = (e) => {
    if (porcent === 0) {
      setPorcent(1);
      setValor(0);
    }
    if (porcent !== 0) {
      setPorcent(0);
    }
    return;
  };

  const verifValor = (e) => {
    const valor = e.target.value;
    if (porcent === 1 && valor > 100) {
      swal("Por favor", "Digite um valor menor que 100%", "warning");
      return;
    }
    handleCupom(e);
  };

  const handleAtivo = (e) => {
    if (verifAtivo === 1) {
      setVerifAtivo(0);
      setAtivo("N");
    }
    if (verifAtivo !== 1) {
      setVerifAtivo(1);
      setAtivo("S");
    }
    return;
  };

  const handleAplicavelChange = useCallback((e, { options, value }) => {
    const text = options
      .filter((option) => value.includes(option.value))
      .map((option) => option.text);
    setAplicavel(value);
  }, []);

  const handleChangedTreinamentos = (value) => {
    setTreinamentos(value);
  };

  const verifEmails = (e) => {
    const string = e.target.value;
    const emailsArray = string.split(" ");

    let ev = {
      target: {
        name: "emails",
        value: emailsArray,
      },
    };

    return handleCupom(ev);
  };

  useEffect(() => {
    const funcAsyncro = async () => {
      const paramsId = props.props.match.params.id;
      const dataCupom = await api.get(`cupons/search/${paramsId}`);
      const cupom = dataCupom.data;
      setRawCupom(cupom);

      const cupomAplicavel = cupom.aplicavel.split(",").map((elem) => {
        if (elem === "boleto") {
          return utilsPaga[0].text;
        }
        if (elem === "cartao_de_credito") {
          return utilsPaga[2].text;
        }
        if (elem === "bitcoin") {
          return utilsPaga[3].text;
        }
        if (elem === "picpay") {
          return utilsPaga[1].text;
        }
        return;
      });
      setAtivo(cupom.ativo);

      setCustomValidade(+cupom?.validade_curso > 0);
      setTestCupom({
        codigo: cupom.codigo,
        desconto: cupom.desconto,
        descricao: cupom.descricao,
        maxUso: cupom.max_uso,
        dataVencimento: cupom.validade,
        emails: cupom.email,
        validadeCurso: cupom?.validade_curso || 0,
      });
      setPorcent(cupom.ispercent);
      setValor(!cupom.ispercent);
      setAplicavel(cupomAplicavel);
      setVerifAtivo(cupom.ativo !== "S" ? 0 : 1);

      if (cupom.max_uso !== 0) {
        setNumMaxUsosDeterminado(true);
      }
      if (cupom.validade !== "0000-00-00" && cupom.validade !== null) {
        setDataVencimentoDeterminada(true);
      }
    };
    funcAsyncro();
  }, []);

  async function updateCupom() {
    const paramsId = props.props.match.params.id;

    const data = {
      codigo: testCupom.codigo.toString().toUpperCase(),
      desconto: testCupom.desconto,
      descricao: testCupom.descricao,
      email: testCupom.emails.toString(),
      treinamentos: treinamentos ? treinamentos.toString() : "",
      aplicavel: aplicavel.toString(),
      ispercent: porcent,
      ativo: ativo,
      max_uso: testCupom.maxUso,
      id_pessoa: aluno,
      validade:
        testCupom.dataVencimento === "Indeterminado"
          ? "Indeterminado"
          : testCupom.dataVencimento,
      validade_curso: customValidade ? testCupom?.validadeCurso : 0,
    };
    const isValid = await cupomSchema.isValid(data);
    if (isValid) {
      setLoading(true);

      await api
        .put(`/admin/cupons/${paramsId}`, data, {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        })
        .then((res) => {
          let logs = {
            local: "cupom",
            texto: `editou o cupom de id=${paramsId}`,
          };
          api.post("system_logs", { acao: JSON.stringify(logs) });
          swal("Cupom Editado", "", "success");
        })
        .catch((err) => {
          swal(
            "Erro ao editar cupom",
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err?.message,
            "error"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
    if (!isValid) {
      swal("Favor preencha todos os campos obrigatórios ", "", "warning");
    }
  }

  return (
    <Form>
      <Form.Field>
        <StyledLabel>Código</StyledLabel>
        <Form.Input
          name="codigo"
          placeholder="ABCDEF010"
          value={testCupom.codigo}
          onChange={handleCupom}
          disabled
        />
      </Form.Field>
      <Form.Field>
        <Checkbox
          label="Esse cupom terá a data de expiração do curso diferente da padrão?"
          onChange={() => setCustomValidade((prev) => !prev)}
          checked={customValidade}
        />
      </Form.Field>
      {customValidade && (
        <Form.Field>
          <StyledLabel>Dias expiração do curso em dias</StyledLabel>
          <Form.Input
            name="validadeCurso"
            placeholder="30"
            value={testCupom.validadeCurso}
            onChange={handleCupom}
          />
        </Form.Field>
      )}
      <Form.Field>
        <StyledLabel>Número máximo de usos</StyledLabel>
        <Dropdown
          placeholder="Indeterminado"
          fluid
          selection
          options={utils}
          value={numMaxUsosDeterminado ? "Determinado" : "Indeterminado"}
          onChange={(e) =>
            e.target.innerText === "Determinado"
              ? setNumMaxUsosDeterminado(!numMaxUsosDeterminado)
              : [
                  setNumMaxUsosDeterminado(false),
                  setTestCupom({ ...testCupom, maxUso: 0 }),
                ]
          }
        />
        {numMaxUsosDeterminado && (
          <ContainerLimitante>
            <Form.Input
              name="maxUso"
              type="number"
              min="1"
              value={testCupom.maxUso}
              onChange={handleCupom}
            />
          </ContainerLimitante>
        )}
      </Form.Field>
      <Form.Field>
        <StyledLabel>Data de vencimento</StyledLabel>
        <Dropdown
          placeholder="Indeterminado"
          fluid
          selection
          options={utils}
          value={dataVencimentoDeterminada ? "Determinado" : "Indeterminado"}
          onChange={(e) =>
            testCupom.dataVencimento !== null &&
            e.target.innerText === "Determinado"
              ? setDataVencimentoDeterminada(!dataVencimentoDeterminada)
              : [
                  setDataVencimentoDeterminada(false),
                  setTestCupom({ ...testCupom, dataVencimento: null }),
                ]
          }
        />
        {dataVencimentoDeterminada && (
          <ContainerLimitante>
            <Form.Input
              name="dataVencimento"
              type="date"
              value={testCupom.dataVencimento}
              onChange={handleCupom}
            />
          </ContainerLimitante>
        )}
      </Form.Field>
      <Form.Field>
        <AlunosSelector
          initialValue={rawCupom?.id_pessoa}
          handleChange={handleAlunoChange}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>
          Desconto:
          <StyledCheck>
            <Checkbox
              label="Porcentagem"
              checked={porcent}
              onChange={(e) => handleInputChangePorcentagem()}
            />
            <StyledCheckboxLeft
              label="Valor"
              checked={valor}
              onChange={(e) => handleInputChangeValor()}
            />
          </StyledCheck>
        </StyledLabel>
        <Form.Input
          name="desconto"
          type="number"
          min="1"
          max={porcent === 1 ? "100" : "10000"}
          value={testCupom.desconto}
          onChange={(e) => verifValor(e)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Aplicável em Pagamentos via:</StyledLabel>
        <Dropdown
          placeholder="Selecione os pagamentos"
          fluid
          multiple
          selection
          value={aplicavel}
          onChange={handleAplicavelChange}
          options={utilsPaga}
        />
      </Form.Field>
      <Form.Field>
        {rawCupom && (
          <TreinamentosSelector
            initialValue={
              rawCupom?.treinamentos?.split(",").map((id) => Number(id)) || []
            }
            multiple
            handleChange={handleChangedTreinamentos}
          />
        )}
      </Form.Field>
      <Form.Field>
        <StyledLabel>Descrição</StyledLabel>
        <StyledLabelRed>
          *Atenção: caso o cupom seja direcionado, será mostrado esse motivo ao
          usuário
        </StyledLabelRed>
        <Form.Input
          name="descricao"
          placeholder="Por que o cupom foi criado?"
          value={testCupom.descricao}
          onChange={handleCupom}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>E-mail Responsável</StyledLabel>
        <Form.Input
          multiple
          selection
          value={testCupom.emails}
          onChange={(e) => verifEmails(e)}
        />
      </Form.Field>
      <StyledCheckbox
        label="Ativo"
        checked={verifAtivo}
        onChange={(e) => handleAtivo()}
      />
      <StyledButton loading={loading} onClick={updateCupom}>
        <i class="edit icon"></i> Editar
      </StyledButton>
    </Form>
  );
};

export default Formulario;
